module.exports = __webpack_public_path__ + "img/demo.fb6c270a.gif";